import DateFormater from "../../../Utils/DateFormater.utils";

const NewMeetingCard = ({ data }) => {
  return (
    <div className="w-full p-1 h-fit flex-col align-start justify-start g-2 radius-6 back-white">
      <span className="w-full text-align-center poppins color-grayColor">
        New meeting created
      </span>

      <div className="flex-col align-start justify-start g-1">
        <div className="flex-row align-start justify-start g-05">
          <span className="poppins t-14 color-black">Time:</span>
          <span className="poppins t-14 color-grayColor">
            {data?.timestamp}
          </span>
        </div>
        <hr color="#DCDBDB" className="w-full" style={{ height: "1px" }} />
      </div>

      <div className="flex-col align-start justify-start g-05">
        <div className="flex-row align-center justify-start g-05">
          <span className="poppins t-14 color-black">Whom:</span>
          <span className="poppins t-14 color-grayColor">
            {data?.details?.whom}
          </span>
        </div>
        <div className="flex-row align-center justify-start g-05">
          <span className="poppins t-14 color-black">Subject:</span>
          <span className="poppins t-14 color-grayColor">
            {data?.details?.subject}
          </span>
        </div>
        <div className="flex-row align-center justify-start g-05">
          <span className="poppins t-14 color-black">Time:</span>
          <span className="poppins t-14 color-grayColor">
            {data?.details?.time}
          </span>
        </div>
        <div className="flex-row align-center justify-start g-05">
          <span className="poppins t-14 color-black">Date:</span>
          <span className="poppins t-14 color-grayColor">
            {DateFormater(data?.details?.date)}
          </span>
        </div>
        <div className="flex-row align-center justify-start g-05">
          <span className="poppins t-14 color-black">Venue:</span>
          <span className="poppins t-14 color-success">
            {data?.details?.venue}
          </span>
        </div>
      </div>
    </div>
  );
};

export default NewMeetingCard;
